import * as React from 'react';
import { Origin } from '../..';
import s from './marketplace-menu.scss';
import { getMenuDataByPlatform } from '../../api/api';
import { config } from '../../config';
import { composer } from '../../component-decorators/composer';
import { SearchBoxContainer } from '../search-box';
import { WithFetcher } from '../../component-decorators/with-fetcher';
import { Box, Sidebar } from 'wix-style-react';
import { useConfigContext } from '../../config-context';
import { ManageAppsMenuItem, BackMenuItem } from '../menu-item';
import { MenuSections } from './menu-sections';
export var dtoToMenuProps = function (res) {
    var _a;
    return (_a = res === null || res === void 0 ? void 0 : res.container) === null || _a === void 0 ? void 0 : _a.sections;
};
export var MarketplaceMenu = composer()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var hideSearchInMenu = _a.hideSearchInMenu, marketplaceStore = _a.marketplaceStore, experiments = _a.experiments;
    var marketplaceMenuClassName = config.origin === Origin.STANDALONE
        ? s.marketplaceMenuSA
        : s.marketplaceMenu;
    // tslint:disable-next-line:react-hooks-nesting
    var _b = useConfigContext(), locale = _b.locale, rpcClient = _b.rpcClient;
    return (React.createElement(WithFetcher, { loader: React.createElement("div", null), initialFetch: function () {
            return getMenuDataByPlatform(marketplaceStore.route, locale, rpcClient);
        }, fetchMemoizationId: "menu-" + locale }, function (_a) {
        var fetchData = _a.fetchData;
        var sections = dtoToMenuProps(fetchData);
        var showManageAppsMenuItem = config.origin === Origin.BIZMGR ||
            config.origin === Origin.EDITOR;
        return (React.createElement("div", { "data-testid": "marketplace-menu", className: marketplaceMenuClassName },
            React.createElement(Sidebar, { dataHook: 'side-bar', skin: "light" },
                React.createElement(Sidebar.PersistentHeader, null,
                    config.goBackToReferrer && React.createElement(BackMenuItem, null),
                    !hideSearchInMenu && (React.createElement(Box, { padding: "18px" },
                        React.createElement(SearchBoxContainer, { isInMenu: true, locale: locale })))),
                React.createElement(Sidebar.Item, null,
                    React.createElement(MenuSections, { sections: sections })),
                showManageAppsMenuItem && (React.createElement(Sidebar.PersistentFooter, null,
                    React.createElement(ManageAppsMenuItem, null))))));
    }));
});
//# sourceMappingURL=marketplace-menu.js.map